import { Tag, TagColor } from '@varo/graphql-schema-types';
import { TagType } from 'shared/components/vxl/Tag/Tag';

export const tagColorMapper = (color: TagColor) => {
  switch (color) {
    case TagColor.Info:
      return TagType.INFO;

    case TagColor.Emphasized:
      return TagType.INFO_EMPHASIZED;

    case TagColor.Reverse:
      return TagType.INFO_REVERSE;

    case TagColor.Positive:
      return TagType.SUCCESS;

    case TagColor.Warning:
      return TagType.WARNING;

    case TagColor.Negative:
      return TagType.ERROR;

    case TagColor.Highlight:
      return TagType.HIGHLIGHT;

    case TagColor.InfoReverse:
      return TagType.INFO_REVERSE;

    default:
      return TagType.INFO;
  }
};

export const formatedTagData = (tags: Tag[]) => {
  return tags?.map((item) => ({
    text: item.text,
    type: tagColorMapper(item?.tagColor),
  }));
};
